const labelsValidationIT = {
    "name": {
        "required": "Il nome dell'etichetta è obbligatorio",
        "unique": "Ops! Questa etichetta esiste già ed è di proprietà di un altro utente. Si prega di provare un altro nome di etichetta. Se possiedi legalmente questo nome di etichetta e ne possiedi il copyright, contatta il nostro team di supporto.",
        "available": "Il nome dell'etichetta è disponibile",
        "invalid": "Il nome dell'etichetta non è valido"
    },
    "year": {
        "required": "L'anno di fondazione è obbligatorio",
        "numeric": "Il valore non è un numero",
        "stringLength": "L'anno di fondazione deve essere lungo 4 cifre"
    },
    "releaseCatalog": {
        "required": "Le uscite nel catalogo sono obbligatorie",
        "numeric": "Il valore non è un numero"
    },
    "logo": {
        "required": "Il logo è obbligatorio",
        "dimensions": "La dimensione del logo dell'etichetta deve essere 1000 x 1000 px, JPG/JPEG/PNG.",
        "choose": "Si prega di scegliere un'immagine",
        "file": "Carica formati JPG o PNG, risoluzione minima 1000x1000px. Dimensione massima 2MB"
    },
    "promo_graphic": {
        "dimensions": "La dimensione della grafica promozionale dell'etichetta deve essere 960 x 150 px, JPG/JPEG/PNG.",
        "choose": "Si prega di scegliere un'immagine",
        "file": "Carica formati JPG o PNG, risoluzione minima 960x150px"
    }
};

export default labelsValidationIT;